import api from '@/api';

export default {
  namespaced: true,
  state: {
    classFees: [],
    guardianBalances: [],
    paymentReceipts: [],
    isLoading: false,
    error: null,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 0
    }
  },
  mutations: {
    SET_CLASS_FEES(state, fees) {
      state.classFees = fees;
    },
      SET_RECEIPTS(state, receipts) {
    state.receipts = receipts;
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = pagination;
  },
    SET_GUARDIAN_BALANCES(state, balances) {
      state.guardianBalances = balances;
    },
    SET_PAYMENT_RECEIPTS(state, receipts) {
      state.paymentReceipts = receipts;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
   
    ADD_CLASS_FEE(state, fee) {
      state.classFees.unshift(fee);
    },
    UPDATE_CLASS_FEE(state, updatedFee) {
      const index = state.classFees.findIndex(f => f.id === updatedFee.id);
      if (index !== -1) state.classFees.splice(index, 1, updatedFee);
    },
    DELETE_CLASS_FEE(state, feeId) {
      state.classFees = state.classFees.filter(f => f.id !== feeId);
    },
    ADD_PAYMENT_RECEIPT(state, receipt) {
      state.paymentReceipts.unshift(receipt);
    },
    UPDATE_GUARDIAN_BALANCE(state, balance) {
      const index = state.guardianBalances.findIndex(b => b.id === balance.id);
      if (index !== -1) state.guardianBalances.splice(index, 1, balance);
    }
  },
  actions: {
    async fetchClassFees({ commit }, params = {}) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get('/class-fees', { params });
        commit('SET_CLASS_FEES', response.data.data);
        commit('SET_PAGINATION', {
          current_page: response.data.meta.current_page,
          last_page: response.data.meta.last_page,
          per_page: response.data.meta.per_page,
          total: response.data.meta.total
        });
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async createClassFee({ commit }, feeData) {
      commit('SET_LOADING', true);
      try {
        const response = await api.post('/class-fees', feeData);
        commit('ADD_CLASS_FEE', response.data.data);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async updateClassFee({ commit }, { id, feeData }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.put(`/class-fees/${id}`, feeData);
        commit('UPDATE_CLASS_FEE', response.data.data);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async deleteClassFee({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        await api.delete(`/class-fees/${id}`);
        commit('DELETE_CLASS_FEE', id);
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async fetchGuardianBalances({ commit }, params = {}) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get('/guardian-balances', { params });
        commit('SET_GUARDIAN_BALANCES', response.data.data);
        commit('SET_PAGINATION', {
          current_page: response.data.meta.current_page,
          last_page: response.data.meta.last_page,
          per_page: response.data.meta.per_page,
          total: response.data.meta.total
        });
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
  async fetchPaymentReceipts({ commit }, params = {}) {
    commit('SET_LOADING', true);
    try {
      const response = await api.get('/payment-receipts', { params });
      commit('SET_RECEIPTS', response.data.data);
      
      // Make sure this matches your API response structure
      commit('SET_PAGINATION', {
        current_page: response.data.meta.current_page,
        last_page: response.data.meta.last_page,
        per_page: response.data.meta.per_page,
        total: response.data.meta.total
      });
      
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  

},
    async createPaymentReceipt({ commit }, receiptData) {
      commit('SET_LOADING', true);
      try {
        const response = await api.post('/payments/payment-receipts', receiptData);
        commit('ADD_PAYMENT_RECEIPT', response.data.data);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async createAdjustment({ commit }, { receiptId, adjustmentData }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.post(`/payment-receipts/${receiptId}/adjustments`, adjustmentData);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    classFees: state => state.classFees,
    guardianBalances: state => state.guardianBalances,
    paymentReceipts: state => state.paymentReceipts,
    isLoading: state => state.isLoading,
    error: state => state.error,
 receipts: state => state.receipts,
  pagination: state => ({
    currentPage: state.pagination.current_page,
    totalPages: state.pagination.last_page,
    perPage: state.pagination.per_page,
    total: state.pagination.total
  }),

}
};